export default "/images/678710e4718bc9d696a66b5f417b4098.avif";